import React, { createContext, ReactNode, useContext } from "react";

const PusherContext = createContext<any>({});

interface IProps {
	pusher: any;
	children?: ReactNode;
}

const PusherProvider = (props: IProps) => {
	return (
		<PusherContext.Provider
			value={{
				pusher: props.pusher,
			}}
		>
			{props.children}
		</PusherContext.Provider>
	);
};

const usePusher = () => {
	const context = useContext(PusherContext);

	if (!context) {
		throw new Error("usePusher must be used within a PusherProvider");
	}

	return context.pusher;
};

const PusherConsumer = PusherContext.Consumer;
export { PusherProvider, PusherConsumer, PusherContext, usePusher };
